import { Dialog, DialogContent, Grid } from "@material-ui/core";
import * as React from "react";
import { Button, SelectInput, useNotify } from "react-admin";
import { Form } from "react-final-form";
import { useAppDataProvider } from "../../../src/dataprovider";
import { UploadFile } from "../../Components/UploadFile";
import { PeriodMonths } from "../../Constants/Constant";
import * as YearList from "../../Constants/YearList";
import CustomLinearProgress from "../../Components/Progress/LinearProgress";

export const AircraftUtilizationUploadFile = props => {
  const [open, setOpen] = React.useState(props.open);
  const [isLoading, setIsLoading] = React.useState(false);
  const dataProvider = useAppDataProvider();
  const _zeroValue: number = 0;
  const notify = useNotify();

  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  const handleClose = () => {
    setOpen(false);
    props?.handleClose?.();
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogContent>
          <Form
            onSubmit={() => {}}
            render={({ form, values }) => {
              return (
                <form>
                  <CustomLinearProgress loading={isLoading} />
                  {isLoading !== true && (
                    <>
                      <SelectInput
                        source="periodYear"
                        choices={YearList.default}
                        optionText="key"
                        optionValue="key"
                        required
                        fullWidth
                      ></SelectInput>
                      <SelectInput
                        source="periodMonth"
                        choices={PeriodMonths}
                        optionText="month"
                        optionValue="value"
                        required
                        fullWidth
                      ></SelectInput>
                      <UploadFile
                        label=""
                        multiple={false}
                        placeholder={"Upload"}
                        onHandleFileExecute={handleClose}
                        setIsLoading={setIsLoading}
                        source="aircraftutilizationfilerelations"
                        object={{
                          aircraftUtilizationId: props?.record?.id,
                          periodYear: values.periodYear,
                          periodMonth: values.periodMonth,
                        }}
                      />
                    </>
                  )}
                  <Grid container justifyContent={"flex-end"}>
                    <Grid item xs={3}>
                      <Button size="medium" label="Close" onClick={handleClose} />
                    </Grid>
                  </Grid>
                </form>
              );
            }}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default AircraftUtilizationUploadFile;
